import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from './design-system/theme/ThemeProvider';
import { GlobalStyles } from './design-system/theme/GlobalStyles';
import * as serviceWorkerRegistration from './services/pwa/serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <GlobalStyles />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log('PWA: Service worker registered successfully');
  },
  onUpdate: (registration) => {
    console.log('PWA: New content is available, please refresh');
  },
  onOffline: () => {
    console.log('PWA: App is running in offline mode');
  },
  onOnline: () => {
    console.log('PWA: App is back online');
  }
});